import { animate, MotionValue, useMotionValue, useMotionValueEvent } from 'framer-motion'

export function useScrollOverflowMask({
  leftInset = '9.69%',
  rightInset = '90.31%',
  scrollXProgress,
}: {
  leftInset?: string
  rightInset?: string
  scrollXProgress: MotionValue<number>
}) {
  const left = '0%'
  const right = '100%'
  const transparent = 'rgba(18, 18, 22, 0.00)'
  const opaque = 'rgba(18, 18, 22, 0.80)'
  const maskImage = useMotionValue(
    `linear-gradient(90deg, ${opaque}, ${opaque} ${left}, ${opaque} ${rightInset}, ${transparent})`,
  )

  useMotionValueEvent(scrollXProgress, 'change', (value) => {
    if (value === 0) {
      animate(
        maskImage,
        `linear-gradient(90deg, ${opaque}, ${opaque} ${left}, ${opaque} ${rightInset}, ${transparent})`,
      )
    } else if (value === 1) {
      animate(
        maskImage,
        `linear-gradient(90deg, ${transparent}, ${opaque} ${leftInset}, ${opaque} ${right}, ${opaque})`,
      )
    } else if (scrollXProgress.getPrevious() === 0 || scrollXProgress.getPrevious() === 1) {
      animate(
        maskImage,
        `linear-gradient(90deg, ${transparent}, ${opaque} ${leftInset}, ${opaque} ${rightInset}, ${transparent})`,
      )
    }
  })

  return maskImage
}
